export class OrdonnanceDto {

    id: number;
    nomMedecin: string;
    etat: string;
    image: any;
    commentaire: string;
    date: Date;
    dateMaj: Date;
    nom: string;
    prenom: string;
    emailPatient: string;
    srcSend: string;
    tel: string;
    images: string[];
    extensions: string[];

    constructor() {
    }

    public static fromJson(json: Object): OrdonnanceDto {
      return new OrdonnanceDto()
        .setId(json['id'])
        .setNomMedecin(json['nom_medecin'])
        .setEtat(json['etat'])
        .setCommentaire(json['commentaire'])
        .setDate(json['date'])
        .setDateMaj(json['date_maj'])
        .setNom(json['nom'])
        .setPrenom(json['prenom'])
        .setTel(json['tel'])
        .setEmail_patient(json['email_patient'])
        .setSrcSend(json['src_send'])
        .setImages(json['images'])
        .setExtensions(json['extensions']);

    }

    setId(id: number) {
      this.id = id;
      return this;
    }

    setNomMedecin(nomMedecin: string){
      this.nomMedecin = nomMedecin;
      return this;
    }

    setEtat(etat: string) {
      this.etat = etat;
      return this;
    }

    setCommentaire(commentaire: string){
      this.commentaire = commentaire;
      return this;
    }

    setDate(date: Date){
      this.date = date;
      return this;
    }

    setDateMaj(dateMaj: Date){
      this.dateMaj = dateMaj;
      return this;
    }

    setNom(nom: string){
      this.nom = nom;
      return this;
    }

    setPrenom(prenom: string){
      this.prenom = prenom;
      return this;
    }

    setTel(tel: string){
      this.tel = tel;
      return this;
    }

    setImages(images: string[]){
      this.images = images;
      return this;
    }

  setExtensions(extensions: string[]){
    this.extensions = extensions;
    return this;
  }


  setEmail_patient(value: string) {
    this.emailPatient = value;
    return this;
  }


  setSrcSend(value: string) {
    this.srcSend = value;
    return this;
  }
}
